import { takeLatest, put, call } from 'redux-saga/effects';
import { actionTypes as applicationActions } from '../core/reducers/asyncServerResponseReducer';
import { historySpecificResponseService } from './../gameservice/specificHistoryResponseService';

export function* specificHistorySaga(): Generator<any, any, any> {
  //yield takeLatest(applicationActions.GET_APPLICATION_HISTORY_RESPONSE, fireSpecificHistoryResponse);
}



let spincount: number = 0
function* fireSpecificHistoryResponse(): Generator<any, any, any> {
  try {


    let result_spin = yield call(historySpecificResponseService.sendSpecifichistoryResponse);  

    //localStorage.setItem("cheatModifiedRequest", "")
    yield put({
      type: applicationActions.GET_APPLICATION_SPECIFIC_HISTORY_RESPONSE,
      result_spin
    });

  } catch (error) {
    yield put({
      type: applicationActions.GET_APPLICATION_SPIN_FAILURE,
      error
    });
  }
}

